import {
  USER_STATUS_CODE_ACTIVE,
  USER_STATUS_CODE_BLOCKED,
  USER_STATUS_CODE_IMPORTED,
  USER_STATUS_CODE_INVITED,
  USER_STATUS_CODE_NOT_CONFIRMED,
} from '../../../../constants/user'

const FULL_PERMISSIONS = {
  can_block_user: true,
  can_create_request: true,
  can_delete: true,
  can_edit: true,
  can_edit_external_id: true,
  can_edit_files: true,
  can_edit_role: true,
  can_manage_all_user_flats: true,
  can_restore: true,
  can_send_invite: true,
  can_start_new_chat: true,
  can_unblock_user: true,
  can_validate: true,
}

const BASE_INHABITANT_MOCK = {
  avatar: null,
  avatar_color: '#9B5BF1',
  externalId: 'EXT-100245',
  id: 9999999,
  invitedAt: '2024-03-15T10:30:00Z',
  is_system: false,
  isArchived: false,
  isLandlord: false,
  permissions: FULL_PERMISSIONS,
  registeredAt: '2024-04-02T08:15:00Z',
}

export const PROFILE_HEADER_INHABITANT_VARIANTS = [
  {
    inhabitantData: {
      ...BASE_INHABITANT_MOCK,
      fullname: 'Jonas Weber',
      status: USER_STATUS_CODE_INVITED,
    },
    label: 'Inhabitant header, status — Invited',
  },
  {
    inhabitantData: {
      ...BASE_INHABITANT_MOCK,
      fullname: 'Maximilian Alexander Friedrich von Habsburg-Lothringen',
      status: USER_STATUS_CODE_ACTIVE,
    },
    label: 'Inhabitant header, status — Online (active)',
  },
  {
    inhabitantData: {
      ...BASE_INHABITANT_MOCK,
      fullname: 'Anna Schmidt',
      status: USER_STATUS_CODE_IMPORTED,
    },
    label: 'Inhabitant header, status — Imported',
  },
  {
    inhabitantData: {
      ...BASE_INHABITANT_MOCK,
      fullname: 'Lukas Müller',
      status: USER_STATUS_CODE_BLOCKED,
    },
    label: 'Inhabitant header, status — Blocked',
  },
  {
    inhabitantData: {
      ...BASE_INHABITANT_MOCK,
      fullname: 'Sophie Becker',
      permissions: { ...FULL_PERMISSIONS, can_edit_role: false },
      status: USER_STATUS_CODE_NOT_CONFIRMED,
    },
    label: 'Inhabitant header, status — Invalid (not confirmed)',
  },
  {
    inhabitantData: {
      ...BASE_INHABITANT_MOCK,
      fullname: 'Elena Fischer',
      isArchived: true,
      permissions: { ...FULL_PERMISSIONS, can_edit_role: false },
      status: USER_STATUS_CODE_ACTIVE,
    },
    label: 'Inhabitant header, archived',
  },
]
